import Vue from 'vue'

import {  addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import tree from "@/extension/tree"

addCustomWidgetSchema({
  type: 'tree',
  icon: 'alert',
  formItemFlag: false,
  options: {
    name: '',
    type: 'info',
    emptyText:'没有类容',//内容为空的时候展示的文本
    nodeKey:'id',//每个树节点用来作为唯一标识的属性，整棵树应该是唯一的
    renderAfterExpand:true, //是否在第一次展开某个树节点后才渲染其子节点
    highlightCurrent:false,//是否高亮当前选中节点，默认值是 false。
    defaultExpandAll:false,//是否默认展开所有节点	
    expandOnClickNode	:true,//是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点。
    checkOnClickNode	:false,//是否在点击节点的时候选中节点，默认值为 false，即只有在点击复选框时才会选中节点。	
    autoExpandParent:true,//展开子节点的时候是否自动展开父节点	
    defaultExpandedKeys:[],//默认展开的节点的 key 的数组	
    showCheckbox		:false,//节点是否可被选择
    checkStrictly	:false,//在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false
    defaultCheckedKeys:[],//默认勾选的节点的 key 的数组	
    currentNodeKey:'',//当前选中的节点
    accordion:false,//是否每次只打开一个同级树节点展开
    indent:16,//相邻级节点间的水平缩进，单位为像素
    iconClass:'el-icon-plus',//自定义树节点的图标
    lazy:false,//是否懒加载子节点，需与 load 方法结合使用	
    draggable:false,//是否开启拖拽节点功能	
    appendNode:false,//是否开启拖拽节点功能	
    customClass: '',
    otherClass:'main-tree-style',
    load:'',//加载子树数据的方法，仅当 lazy 属性为true 时生效 function(node, resolve)
    renderContent:'',//树节点的内容区的渲染 Function	Function(h, { node, data, store }
    filterNodeMethod:'',//对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏 Function(value, data, node)
    allowDrag:'',//判断节点能否被拖拽 Function(node)
    allowDrop	:'',//    customClass: '',拖拽时判定目标节点能否被放置。type 参数有三种情况：'prev'、'inner' 和 'next'，分别表示放置在目标节点前、插入至目标节点和放置在目标节点后	 Function(draggingNode, dropNode, type)
    handleNodeClick:'',
    handleCheckChange:'',
    appendFunc:'',
    url:''
  }
})  //加载组件Json Schema

Vue.component(tree.name, tree)  //注册组件

// 注册属性编辑框
PERegister.registerCPEditor('emptyText', 'emptyText-editor',
PEFactory.createInputTextEditor('emptyText', '内容为空'))

PERegister.registerCPEditor('nodeKey', 'nodeKey-editor',
PEFactory.createInputTextEditor('nodeKey', '唯一标识'))

PERegister.registerCPEditor('currentNodeKey', 'currentNodeKey-editor',
PEFactory.createInputTextEditor('currentNodeKey', '当前选中的节点'))

PERegister.registerCPEditor('renderAfterExpand', 'renderAfterExpand-editor',
PEFactory.createBooleanEditor('renderAfterExpand', '展开后渲染其子节点'))

PERegister.registerCPEditor('highlightCurrent', 'highlightCurrent-editor',
PEFactory.createBooleanEditor('highlightCurrent', '选中高亮'))

PERegister.registerCPEditor('defaultExpandAll', 'defaultExpandAll-editor',
PEFactory.createBooleanEditor('defaultExpandAll', '默认展开所有节点'))

PERegister.registerCPEditor('expandOnClickNode', 'expandOnClickNode-editor',
PEFactory.createBooleanEditor('expandOnClickNode', '展开或者收缩节点'))

PERegister.registerCPEditor('checkOnClickNode', 'checkOnClickNode-editor',
PEFactory.createBooleanEditor('checkOnClickNode', '点节点选中节点'))

PERegister.registerCPEditor('autoExpandParent', 'autoExpandParent-editor',
PEFactory.createBooleanEditor('autoExpandParent', '自动展开父节点'))

PERegister.registerCPEditor('defaultExpandedKeys', 'defaultExpandedKeys-editor',
PEFactory.createInputTextEditor('defaultExpandedKeys', '默认展开的节点'))

PERegister.registerCPEditor('showCheckbox', 'showCheckbox-editor',
PEFactory.createBooleanEditor('showCheckbox', '节点是否可被选择'))

PERegister.registerCPEditor('checkStrictly', 'checkStrictly-editor',
PEFactory.createBooleanEditor('checkStrictly', '父子不互相关联'))

PERegister.registerCPEditor('defaultCheckedKeys', 'defaultCheckedKeys-editor',
PEFactory.createInputTextEditor('defaultCheckedKeys', '默认勾选的节点'))

PERegister.registerCPEditor('accordion', 'accordion-editor',
PEFactory.createBooleanEditor('accordion', '只打开一个同级树节'))

PERegister.registerCPEditor('indent', 'indent-editor',
PEFactory.createInputNumberEditor('indent', '缩进像素'))

PERegister.registerCPEditor('iconClass', 'iconClass-editor',
PEFactory.createInputTextEditor('iconClass', '自定义树节点的图标'))

PERegister.registerCPEditor('otherClass', 'otherClass-editor',
PEFactory.createInputTextEditor('otherClass', '样式'))

PERegister.registerCPEditor('appendNode', 'appendNode-editor',
PEFactory.createBooleanEditor('appendNode', '是否添加按钮'))

PERegister.registerCPEditor('lazy', 'lazy-editor',
PEFactory.createBooleanEditor('lazy', '懒加载子节点'))

PERegister.registerCPEditor('draggable', 'draggable-editor',
PEFactory.createBooleanEditor('draggable', '是否开启拖拽节点'))


PERegister.registerEPEditor('handleNodeClick', 'handleNodeClick-editor',
PEFactory.createEventHandlerEditor('handleNodeClick', ['data','node','tree']))

PERegister.registerEPEditor('handleCheckChange', 'handleCheckChange-editor',
PEFactory.createEventHandlerEditor('handleCheckChange', ['data','checked','indeterminate']))

PERegister.registerEPEditor('load', 'load-editor',
PEFactory.createEventHandlerEditor('load', ['node','resolve']))

PERegister.registerEPEditor('appendFunc', 'appendFunc-editor',
PEFactory.createEventHandlerEditor('appendFunc', ['data']))

// PERegister.registerEPEditor('renderContent', 'renderContent-editor',
// PEFactory.createEventHandlerEditor('renderContent', ['h','{node,data,store}']))

// PERegister.registerEPEditor('filterNodeMethod', 'filterNodeMethod-editor',
// PEFactory.createEventHandlerEditor('filterNodeMethod', ['value','data','node']))

// PERegister.registerEPEditor('allowDrag', 'allowDrag-editor',
// PEFactory.createEventHandlerEditor('allowDrag', ['node']))

// PERegister.registerEPEditor('allowDrop', 'allowDrop-editor',
// PEFactory.createEventHandlerEditor('allowDrop', ['draggingNode','dropNode','type']))